import type { BlackBtcConfig } from './config';

export type ThirdwebBalanceResult = {
  available: boolean;
  displayValue?: string;
  value?: string;
  decimals?: number;
  message?: string;
};

export async function readThirdwebBalance(
  config: BlackBtcConfig,
  walletAddress: string,
): Promise<ThirdwebBalanceResult> {
  if (!config.backendUrl || !config.thirdwebReady) return { available: false };
  try {
    const response = await fetch(`${config.backendUrl}/api/black-btc/balance`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ walletAddress }),
    });
    const result = await response.json() as ThirdwebBalanceResult;
    if (!response.ok) return { available: false, message: result.message ?? 'Thirdweb balance check failed.' };
    return { ...result, available: true };
  } catch {
    return { available: false, message: 'Thirdweb balance service is unavailable.' };
  }
}


